import PropTypes from "prop-types";
import ReactNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Breadcrumbs } from "components/Breadcrumbs";
import { isMobileDevice } from "utils/index";
import { NotificationPanel } from "features/Notification/v2/Panel";
import {
  Search,
  AccountDropdown,
  BankConnectionAction,
  HamburgerToggle,
} from "../Components";

export const NavbarDashboard = ({ onPlaidSuccess, onTransferFunds }) => {
  const isMobile = isMobileDevice();

  return (
    <>
      <HamburgerToggle />

      <ReactNavbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end"
      >
        <Breadcrumbs />

        <Nav>
          <div className="logged-in-options">
            <BankConnectionAction
              handlePlaidSuccess={onPlaidSuccess}
              handleTransferFunds={onTransferFunds}
            />
            {!isMobile && <Search id="desktop-search" />}
            <NotificationPanel />
          </div>

          <AccountDropdown />
        </Nav>
      </ReactNavbar.Collapse>
    </>
  );
};

NavbarDashboard.propTypes = {
  onPlaidSuccess: PropTypes.func.isRequired,
  onTransferFunds: PropTypes.func.isRequired,
};
